import { useMemo } from 'react';
import DependencyFlowHelper from '../../helper/DependencyFlowHelper';
import { useGlobalAppStateStore } from '../app/GlobalAppStateStore';
import { useGlobalStateStore } from '../GlobalStateStore';

export function usePageUnstagedDataSourceIds() {
  const pageDsDependencyFlow = useGlobalStateStore().hooks.dataSource.useDependencyFlow();
  return DependencyFlowHelper.getUnstagedDependencies({
    dependencyFlowInstance: pageDsDependencyFlow,
  });
}

export function useAppUnstagedDataSourceIds() {
  const appDsDependencyFlow = useGlobalAppStateStore().hooks.dataSource.useDependencyFlow();
  return DependencyFlowHelper.getUnstagedDependencies({
    dependencyFlowInstance: appDsDependencyFlow,
  });
}

export function useUnstagedDataSourceIds() {
  const appUnstagedDataSourceIds = useAppUnstagedDataSourceIds();
  const pageUnstagedDataSourceIds = usePageUnstagedDataSourceIds();

  const completeUnstagedDataSourceIds = useMemo(() => {
    return [...appUnstagedDataSourceIds, ...pageUnstagedDataSourceIds];
  }, [appUnstagedDataSourceIds, pageUnstagedDataSourceIds]);

  return completeUnstagedDataSourceIds;
}

export function useDataSourcePreviewResult(dataSourceId: string) {
  const appDataSourceMeta =
    useGlobalAppStateStore().hooks.dataSource.usePreviewResult(dataSourceId);
  const pageDataSourceMeta = useGlobalStateStore().hooks.dataSource.usePreviewResult(dataSourceId);

  return appDataSourceMeta ?? pageDataSourceMeta;
}

export function usePageFunctionResult(pageFunctionId: string) {
  const activePageFunctionResult =
    useGlobalStateStore().hooks.pageFunction.useResult(pageFunctionId);
  const globalPageFunctionResult =
    useGlobalAppStateStore().hooks.pageFunction.useResult(pageFunctionId);

  return activePageFunctionResult ?? globalPageFunctionResult;
}

export function usePageVariableResult(pageVariableId: string) {
  const activePageVariableResult =
    useGlobalStateStore().hooks.pageVariable.useResult(pageVariableId);
  const globalPageVariableResult =
    useGlobalAppStateStore().hooks.pageVariable.useResult(pageVariableId);

  return activePageVariableResult ?? globalPageVariableResult;
}

export function usePageVariablesResult() {
  const activePageVariables = useGlobalStateStore().hooks.usePageVariables();
  const globalPageVariables = useGlobalAppStateStore().hooks.usePageVariables();

  // need this memo because these values are used in schema generation and that is in useEffect
  return useMemo(() => {
    return {
      ...activePageVariables,
      ...globalPageVariables,
    };
  }, [activePageVariables, globalPageVariables]);
}

export function usePageFunctionsResult() {
  const activePageFunctions = useGlobalStateStore().hooks.usePageFunctions();
  const globalPageFunctions = useGlobalAppStateStore().hooks.usePageFunctions();

  // need this memo because these values are used in schema generation and that is in useEffect
  return useMemo(() => {
    return {
      ...activePageFunctions,
      ...globalPageFunctions,
    };
  }, [activePageFunctions, globalPageFunctions]);
}
